
import Content from './pages/Content'
import Load from './pages/load/Load'
import './App.css'
import AppProvider from './context/AppProvider';

function App() {

  return (
    <AppProvider>
      <div className="App">
        <Load />
        <Content />
      </div>
    </AppProvider>
    
  );
}

export default App;
